import React from "react";
import "./ProductCard.scss";

export default function SkeletonCard() {
  return <div class="card"></div>;
}
